import { defineSetting } from '../settingsRegistry';

declare module '../settingsRegistry' {
  interface Settings {
    /** Floating damage numbers and combat words. */
    damageNumbers: boolean;
  }
}

defineSetting({
  key: 'damageNumbers',
  default: true,
  order: 80,
  menu: { group: 'visual', label: 'ตัวเลขความเสียหาย' },
});
